import styled from "styled-components";
import closeIconblack from "../../../images/close-Icon-black.svg";
import closeIconWhite from "../../../images/error-close-icon.svg";
import rightorangearrow from "../../../images/right-orange-arrow-small.svg";
import RejectionIndicator from "../../../images/RejectionIndicator.png";
import OrphanedIndicator from "../../../images/OrphanedIndicator.png";
import ProfilePicModal from "../../../images/photostitle.svg";

export const FeedsWrapper = styled.div`
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    width:99%;
    height: auto;
    max-height: 83vh;
    margin-top:4%;
    padding:0 20px 0 0;
    & ul{
        display: flex;
        flex-wrap: wrap;
        padding-bottom:1.5rem;
    }
    ::-webkit-scrollbar {
        width: 3.5px;
        border-radius: 9px;
    }   

    ::-webkit-scrollbar-track {
        background-color: #FFF;
        width: 5px;
        border-radius: 9px;
    }   

    ::-webkit-scrollbar-thumb {
        background-color: #C1C1C1;
        border-radius: 9px;
        width: 5px;
    }  

    {
      -ms-overflow-style: none;
      scrollbar-width: thin;
    }

     @media screen and (max-width: 750px){
        {
            position: static;
            max-height: max-content;
            overflow-y: inherit;
            padding:0px;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
    and (orientation: portrait){
        position: static;
        max-height: 100vh;
        overflow-y: auto;
        padding: 0px 0px;
        overflow-x: hidden;
    }
`;


export const FilterButtons = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction:row;
    // justify-content: space-evenly;
    // background: rgba(243, 243, 243, 1);
    padding:8px;
    & select{
        margin: 0 auto 1% 5%;
        border: 1px solid #8c8c8c;
        border-radius:5px;
        width: 50%;
        height: 32px;
        cursor:pointer;
    }
    & select option {
        cursor: pointer !important;
      }
    & select option:hover {
        cursor: pointer !important;
      }
`

export const OnlyReadButton = styled.button`{
    // position: relative;
    width: auto;
    height: auto;
    padding: 9px 18px 11px 18px;
    border-radius: 20px;
    background: var(--wv-tints-shades-wv-grey-sky-light, #E6E6E6);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px 0px;
    color: var(--wv-black-soft, #111);
    text-align: center;
    font-family: Lato-bold;
    font-size: 16px;
    line-height: 120%;
    margin-right: 5%;
    // @media screen and (max-width: 400px){
    //     left: 55%;
    // }
}`;

export const OnlyNewButton = styled.button`{
    // position: relative;
    width: auto;
    height: auto;
    border-radius: 20px;
    padding: 9px 18px 11px 18px;
    background: var(--wv-tints-shades-wv-grey-sky-light, #E6E6E6);
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px 0px;
    color: var(--wv-black-soft, #111);
    text-align: center;
    font-family: Lato-bold;
    font-size: 16px;
    line-height: 120%;
    cursor: pointer;
    // left: 22.5vw;
    // top: 12px;
    // background: url(${rightorangearrow}) 0 0;
    // @media screen and (max-width: 400px){
    //     left: 55%;
    // }
}`;
export const UpdateButton = styled.div`
     display: flex;
     margin-left: 15px;
     padding-top: 10px;
     @media screen and (min-width: 1200px){
        margin-top:${({childfeeds}) => (childfeeds? "5%": "")};
    }
`
export const UnreadText = styled.span`
     font-size: 26px;
     font-family: "Lato-bold";
     color: "#000";
`
export const UnreadCount = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    background-color: #FF6B00;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    position: relative;
    bottom: 8px;
`
export const ConnectFeedsWrapper = styled.div`
    position: absolute;
    width:27vw;
    height: auto;
    max-height: 80vh;
    margin-top:4%;
    // bottom: 21%;
    overflow-y: auto;
    left:73vw;
    overflow-x: hidden;
    @media screen and (min-width: 1600px){
        left:73.5vw;
    }
    @media screen and (min-width: 1200px) and (max-width:1400px){
        left:72.5vw;
    }
   
    @media screen and (max-width: 749px){
        {
            margin-top:0;
            position: relative;
            width: 100%;
            left: 10px;
            top: 10vh;
            margin-bottom: 25%;
            overflow-y: inherit;
            height:auto;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            top:0vh;
            margin-top:0;
            position: relative;
            width: 100%;
            left: 10px;
            margin-bottom: 25%;
            overflow-y: inherit;
            max-height: auto;
        }
        ul{
            padding-left: 0rem;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
       
        ul{
            padding-left: 1.3rem;
        }
    }
    @media screen and (max-width: 540px){
        {
            margin-bottom: 10%;
            top: 2vh;
        }
        & ul{
            padding-left:1rem;
        }
    }
`;

export const ConnectDisclaimer = styled.div`
    position: absolute;
    width:25vw;
    height: 10.3vh;
    bottom:4%;
    overflow-y: auto;
    border-radius: 5px;
    background: #FFF;
    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.25);
    right:0.5%;
    overflow-x: hidden;
    & span{
        position: relative;
        height:auto;
        width: auto;
        left: 1vw;
        top:1vh;
        color: #000;
        font-family: Lato-bold;
        font-size: 12px;
        font-style: normal;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    
    & p{
        position: relative;
        height:auto;
        // width: 23.2vw;
        left: 1vw;
        top: 1vh;
        color: #4E4C4C;
        font-family: Lato;
        font-size: 11px;
        font-style: normal;
        font-weight: 400;
        line-height: 135%;
        letter-spacing: 0.11px;
        width:95%;
    }
    @media only screen and (min-width:1200px) and (max-width:1400px){
        height: 12.5vh;
    }
    @media screen and (max-width: 749px){
        width:96%;  
        left:1vw;
        overflow-x: clip;
        height: auto;
        bottom:1%;
        margin: 0 auto;
    }
    
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width:96%;  
        left:1vw;
        right:1vw;
        overflow-x: clip;
        height: auto;
        bottom:3%;
        margin: 0 auto;
    }

`;

export const SearchWrapper = styled.div`
    position: relative;
    top:13vh;
    left:1.5vw;
    width:90%;
    height:6vh;
    display:flex;
    border-radius: 32px;
    border: 1px solid var(--wv-tints-shades-wv-grey-sky-light, #E6E6E6);
    background: var(--wv-white, #FFF);
    & img{
        position:relative;
        display:flex;
        height:3vh;
        width:3vh;
        transform: translate(50%, 50%);
        margin-top: 0px;
    }
    & input{
        position:relative;
        display:flex;
        left: 3vh;
        width:17vw;
        ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: #535353;
            font-family: Lato-bold;
            font-size: 16px;
            font-style: normal;
            line-height: 135%;
            letter-spacing: 0.14px;
            }

            :-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: #535353;
                font-family: Lato-bold;
                font-size: 16px;
                font-style: normal;
                line-height: 135%;
                letter-spacing: 0.14px;
            }

            ::-ms-input-placeholder { /* Microsoft Edge */
                color: #535353;
                font-family: Lato-bold;
                font-size: 16px;
                font-style: normal;
                line-height: 135%;
                letter-spacing: 0.14px;
            }
    }
    @media screen and (max-width: 850px){
        top: 7vh;
    }
`;

export const FeedWrapper = styled.div`
    flex-basis: ${({station}) => (station ? "46%" : "100%")};
    margin: ${({station}) => (station ? "0px 20px;" : "unset")};
    width:auto;
    flex-direction: row;
    cursor: pointer;
    border-bottom: 2px solid rgb(239, 239, 239);
    position:relative;
    &:nth-child(odd)::after{
        content: "";
        position: absolute;
        right: -20px;
        bottom: 0;
        width: ${({station}) => (station ? "2px" : "0")};
        height: 102%;
        background-color: rgb(239, 239, 239);
        top:0px;
        @media screen and (min-width: 1200px) and (max-width:1400px) {
            {
                height: 104%;
            }
        }
    }
    @media screen and (min-width: 1200px) and (max-width:1470px) {
        {
            margin: ${({station}) => (station ? "0px 15px;" : "unset")};
        }
    } 
    @media screen and (max-width: 750px){
        {
            flex-basis: 100%;
            //margin: unset;
            &:nth-child(odd)::after{
                width: ${({station}) => (station ? "0px" : "0")};
            }
            &:nth-child(odd){
                margin: ${({station}) => (station ? "0 20px 0 20px;" : "unset")};
            }
        }
    }  
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        flex-basis: ${({station}) => (station ? "45%" : "100%")};
        margin: ${({station}) => (station ? "10px 20px;" : "unset")};
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: portrait){
        &:nth-child(odd)::after{
            width: ${({station}) => (station ? "0px" : "0")};
        }
        &:nth-child(odd){
            margin: ${({station}) => (station ? "10px 20px;" : "unset")};
        }
      }
`;

export const ConnectFeedWrapper = styled.div`
    position: relative;
    width:auto;
    height: ${({ isMessageReceived, isDelayedFeed, isErrorDescription }) => {
        if (isDelayedFeed || isErrorDescription) {
          return "100px"; 
        }
        return isMessageReceived ? "145px" : "180px";
      }};
    display: flex;
    margin:16px 0;
    flex-direction: row;
    background-color: ${(props) => (props?.draft ? "rgb(254 239 228)": props?.status ? "#84BBF133" : "#fff")};
    @media screen and (max-width: 850px){
        height: ${({ isMessageReceived, isDelayedFeed, isErrorDescription }) => {
            if (isDelayedFeed || isErrorDescription) {
              return "115px"; 
            }
            return isMessageReceived ? "145px" : "195px";
          }};
        width: 95%;
        background-color: ${(props) => (props?.draft ? "rgb(254 239 228)": props?.status ? "#84BBF133" : "#fff")};
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        height: ${({ isMessageReceived, isDelayedFeed, isErrorDescription }) => {
            if (isDelayedFeed || isErrorDescription) {
              return "135px"; 
            }
            return isMessageReceived ? "145px" : "190px";
          }};
    }
    @media screen and (min-width: 1200px) and (max-width:1400px) {
        height: ${({ isMessageReceived, isDelayedFeed, isErrorDescription }) => {
            if (isDelayedFeed || isErrorDescription) {
              return "115px"; 
            }
            return isMessageReceived ? "145px" : "200px";
          }};
          margin: 16px 0;
    }   
    @media screen and (min-width: 1400px) and (max-width:1600px) {
        height: ${({ isMessageReceived, isDelayedFeed, isErrorDescription }) => {
            if (isDelayedFeed || isErrorDescription) {
              return "115px"; 
            }
            return isMessageReceived ? "145px" : "180px";
          }};
          margin: 16px 0;
    }   
    :after{
        position: absolute;
        left: 0;
        content: " ";
        display: block;
        border-bottom: 2px solid #EEEEEE;
        width: 100%;
        bottom:-5px;
        @media screen and (max-width: 850px){
            margin-left: -4%;
        }
        @media screen and (min-width: 1401px) and (max-width:1600px) {
            bottom: 0;
        } 
        @media screen and (min-width: 1200px) and (max-width:1400px) {
            bottom: 0;
        }   
    }
}`;

export const FeedContent = styled.div`
    flex: 65;
    width:100%;
    margin-left:${({station}) => (station ? "5%" : "0%")} !important;
    
    @media screen and (min-width: 1244px){
        flex:75;
    }
    @media screen and (max-width: 749px){
        width:95%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: portrait){
        width:95%;
      }
`;
export const FeedContentTitle = styled.div`
      padding:5px 15px;
      margin-bottom:1em;
      background:#006AC1;
      width:fit-content;
      border-radius:12px;
`
export const FeedContentImage = styled.div`
      width:100%;
      & img {
        width:100%;
        @media screen and (max-width: 750px){
            width: 125%;
            margin-left: -1em;
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
        {
            width: 125%;
            margin-left: -2em;
        }
      }
`;

export const ConnectFeedImg = styled.div`
    & img{
        position: relative;
        left:1vw;
        top:1vh;
        width: 28px;
        height: 28px;
        border-radius:22px;
        object-fit:cover;
        @media screen and (max-width: 600px){
            left:0vw;
            width: 40px;
            height: 40px;
        }
        @media screen and (min-width: 600px) and (max-width: 850px){
            width: 50px;
            height: 50px;
            border-radius:25px;
        }
    }
`;

export const ConnectPopupImg = styled.span`
    // position: relative;
    left: 4%;
    top: 6%;
    ${props => props.progress && `
            top: 2%;
        `}
    @media screen and (min-width: 1400px){
        left: 6%;
        top: 1%;
        & img{
            width: 50px;
            height: 50px;
        }
    }
    @media screen and (max-width: 850px){
        top: 4%;
        border-radius:50%;
    }
    & img{
        width: 41px;
        height: 41px;
        border-radius:50%;
    }
`;

export const OpenConnectFeed = styled.button`{
    position: absolute;
    width: 15px;
    height: 20px;
    left: 22.5vw;
    top: 12px;
    background: url(${rightorangearrow}) 0 0;
    @media screen and (max-width: 850px){
        left: 85%;
    }
}`;

export const ConnectFeedContent = styled.div`
    flex: 60;
    width:auto;
    max-height: 14vh;
    display:flex;
    flex-direction:column;
    margin-top:3px;
    @media screen and (min-width: 360px) and (max-width: 850px){
        max-height: 16vh;
    }
    @media screen and (min-width: 600px) and (max-width: 850px){
        position:relative;
        left:3%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        max-height: 20vh;
    }
`;

export const LineWrapper = styled.div`
    display:flex;
    flex-direction:row;
    margin-left:1.5vw;
    gap:5px;
    @media screen and (min-width: 1200px) and (max-width:1400px) {
         gap:5px;
    }
`;

export const PopupLineWrapper = styled.div`
    // position:relative;
    display:flex;
    flex-direction:row;
    // top: -2vh;
    left: 11%;
    ${props => props.responsePopup && `
        left: 9%;
    `}
    ${props => props.progress && `
    top: -6%;
    `}
    @media screen and (max-width: 414px){
        left: 18%;
        ${props => props.progress && `
          top: -2%;
        `}
    }
    @media screen and (min-width: 370px) and (max-width: 850px){
        top: -4%;
        left: 12%;
        ${props => props.progress && `
          margin-top: 2%;
          margin-left: 3%;
        `}
    }
`;

export const MsgWrapper = styled.div`
    position:relative;
    padding-left:1.5vw;
    // height:45px;
    width:19vw;
    flex-direction:row;
    color: #111111;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    line-height: 135%;
    font-weight: 500;
    letter-spacing: 0.16px;
    overflow: clip;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    margin:10px 0;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
            & {
                -webkit-line-clamp: 1;
                
            }
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
        {
            & {
                -webkit-line-clamp: 1;
                margin-bottom:10px;
            }
        }
    ${props=> props.draft && `
        -webkit-line-clamp: 4;
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
        {
            & {
                -webkit-line-clamp: 4;
            }
        }
        @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
        {
            & {
                -webkit-line-clamp: 3;
            }
        }
    `}
    ${props=> props.rejectedMessage && `
        font-size: 16px;
        font-weight: 400;
        font-family: 'Lato-Bold';
        margin-top:3%;
        :before{
            background: url(${RejectionIndicator}) 0 0;
            content:" ";
            width:16px;
            height:16px;
            position:absolute;
            left:0;
            top:2px;
            background-size:contain;
            @media screen and (max-width: 600px){
                left:-1.5px;
            }
        }
        @media screen and (max-width: 600px){
            left:-3vw;
            padding-left:4.5vw;
        }
         
    `}
    ${props=> props.isOrphanedFeed && `
        margin-top:3%;
        & :before{
            background: url(${OrphanedIndicator}) 0 0;
            content:" ";
            width:16px;
            height:16px;
            position:absolute;
            left:0;
            top:2px;
            background-size:contain;
            @media screen and (max-width: 600px){
                left:-1.5px;
            }
        }
        @media screen and (max-width: 600px){
            left:-3vw;
            padding-left:4.5vw;
        }
         
    `}
    @media screen and (max-width: 850px){
        width: 93%;
    }
`;

export const NoFeedText = styled.p`
    position:relative;
    top: 20vh;
    height:45vh;
    color: #111;
    text-align: center;
    font-size: 16px;
    font-family: Lato;
    line-height: 135%;
    letter-spacing: 0.16px;
    @media screen and (max-width: 850px){
        top: 2vh;
        height:auto;
    }
`;

export const FeedTextPlan = styled.p`
    // display: -webkit-box;
    // -webkit-line-clamp: 5;
    // -webkit-box-orient: vertical;
    // overflow: hidden;   
    width:auto;
    // height: 10vh;
    font-family: Lato;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    color: #000000;
    margin-bottom:0;
    padding:1em 0 0em;
    & strong {
        color: #FF6B00;

    }
`;
export const FeedText = styled.p`
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;   
    width:auto;
    // height: 10vh;
    font-family: Lato;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    color: #000000;
    margin-bottom:0;
    //padding:1em 0 0em;
    & strong {
        color: #FF6B00;

    }
`;
export const ConnectFeedTextDraft = styled.div`
    display: flex;
    align-items: center;
    & span{
        margin-right: 20%;
        position: relative;
        border-radius: 50%;
        padding: 2px 5px;
        background-color: orange;
        color: white;
        font-size: 12px;
        font-family: 'Lato-SemiBold';
    }
`
export const ConnectFeedText = styled.p`
    position:relative;
    width:18.5vw;
    height: auto;
    left:1.5vw;
    top:1.2vh;
    color: #111;
    font-family: Lato-Bold;
    font-size: 17px;
    font-style: normal;
    line-height: 120%;
    @media screen and (max-width: 850px){
        width:75%;
    }
    & span{
        margin-right:0;
    }
`;
export const ConnectSubjectText = styled.p`
    position:relative;
    width:18.5vw;
    height: auto;
    left:1.5vw;
    // bottom:px;
    color: #111;
    font-family: Lato-Bold;
    font-size: 16px;
    font-style: normal;
    line-height: 120%;
    @media screen and (max-width: 850px){
        width:75%;
    }
    @media screen and (min-width: 1100px) and (max-width: 1300px){
        margin-bottom:${props => props.rejected && 0}
    }
`;

export const FeedDate = styled.p`
    position:relative;
    width:auto;
    height: auto;
    // bottom: 13px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: #474747;
    ${props => props.srspopup && `
        left: 5%;
    `}
    @media (min-width: 1023px) and (max-width: 1024px){
        margin-bottom: 0rem;
    }
`;

export const PhotosTitle = styled.div`
    font-family: Lato;
    font-size: 24px;
    font-weight: 600;
    line-height: 33.6px;
    letter-spacing: 0.01em;
    margin: 3% 0 0 3%;
    : after {
        background: url(${ProfilePicModal}) 0 0;
        content:" ";
        width:36px;
        height:36px;
        position:absolute;
        margin: 0 0 0 1%;
        top:5%;
        @media screen and (max-width: 740px){
            top:2%;
        }
    }
    
`

export const FeedStatus=styled.p`
    position:relative;
    width:auto;
    height: auto;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    color: #474747;
    margin-left: 4px;
`

export const FeedStatusIcon=styled.img`
    width: 8px;
    height: 8px;
    margin-left: 10px;
    position:relative;
    margin-top: 4px;
`

export const FeedIcon = styled.div`
    flex: 40;
    width:auto;
    text-align:center;
    margin: 0 0 5% 0;
    @media screen and (max-width: 850px){
        flex: 30;
    }
`;

export const ImageIcon = styled.div`
 & img{
    // position: absolute;
  ///  right: 30px;
    max-width: 13vh;
    max-height: 11vh;
    width:auto;
    height;auto;
    border: 2px solid #FFFFFF;
    object-fit: cover;
    ${props => !props.isMilestone && `
    filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.2));
    transform: rotate(2.5deg);
    `} 
    @media screen and (max-width: 750px){
        max-height: 7vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            max-height: 7vh;
        }
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            max-height: 7vh;
        }
    }
    }   
`;


export const VideoIcon = styled.div`
    width: 6vw;
    height: 8vh;
    border: 2px solid #FFFFFF;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.2);
    transform: rotate(2.5deg);
    background: rgba(0, 0, 0);
    background-image: url(${(props) => props.image});
    background-size: cover;
    background-position: center;
    margin: 0 auto;
    & img{
        position: absolute;
        width: 3vh;
        height: 3vh;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    @media screen and (max-width: 750px){
        width: 10vh;
        height: 8vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        width: 11vw;
        height: 7vh;
    }
`;

export const PDFIcon = styled.div`
& img{
    // position: absolute;
    // right: 35px;
    max-width: 11vh;
    max-height: 11vh;
    width:auto;
    height:auto;
    border: 2px solid #FFFFFF;
    filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.2));
}
    transform: rotate(-2.61deg);
`;

export const SRSIcon = styled.div`
& img{
    height:auto;
    width:auto;
    max-width: 5.5vw;
    max-height: 9.5vh;
    border: 3px solid #FFFFFF;
    border-radius: 50%;
    @media screen and (max-width: 750px){
        max-width: 8vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            max-width: 7vh;
        }
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            max-width: 9.5vh;
        }
    }
}
`;

export const Seperator = styled.div`
    position:relative;
    bottom: 8px;
    border: 1px solid #EEEEEE;
`;

export const Seperator3 = styled.div`
    position:relative;
    bottom: -2.2vh;
    left: 4.5vh;
    width:42vh;
    border: 1px solid #EEEEEE;
`;

export const Seperator2 = styled.div`
    position:relative;
    right:2.5vw;
    left:${({privacy}) => (privacy ? "0" : "2.5vw")};
    top:${({privacy}) => (privacy ? "2.5vh" : "0")};
    width:${props=>props?.donation?"90%":  props?.privacy ? "42vw": "65vw"};
    border: 1px solid #C9C9C9;
    @media only screen and (max-device-width: 750px){
        width:100%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            width:100%;
        }
    }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            width:100%;
        }
    }
`;
export const SeperatorMyAccount = styled.div`
    position:relative;
    left:0.1vw;
    top:0px;
    width:95%;
    border: 1px solid #C9C9C9;
    margin: 15px 0;
    @media only screen and (max-device-width: 750px){
        width:100%;
    }
`;
export const VerticalSeparator = styled.div`
    position:relative;
    left:52vh;
    top:-78.2vh;
    width: 58.5vh;
    height: 83vh;
    fill: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 36.74%, #F9F9F9 90.00%);
    @media screen and (max-width: 850px){
        position: unset;
        width: 90%;
    }
`;

export const LeftWrapper = styled.div`
    display:flex;
    flex-direction:column;
`;
export const LeftStatus = styled.div`
    display:flex;
    flex-direction:column;
    margin-left:3%;
    margin-right:3%;
    margin-right:3%;
   width: 100%;  
`;

export const RightWrapper = styled.div`
   background: linear-gradient(270deg, rgba(255, 255, 255, 0) 36.74%, #F9F9F9 90%);
    backgroung:rgb(243, 243, 243);
    margin-top: 50px;
    @media screen and (min-width: 1200px){
        {
            margin-left:5%;
            overflow: hidden auto;
        }
    } 
`;

export const FeedModalBackground = styled.div`
    position:fixed;
    top:0px;
    left:0px;
    z-index: 12;
    display: ${({show}) => (show ? "block" : "none")};
    height: 100%;
    width:100%;
    display:flex;
    background:#111111;
    opacity:50%;
`;


export const SaftyModalBackground = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
    display: ${({show}) => (show ? "block" : "none")};
    height: 100%;
    width:100%;
    display:flex;
    background:#111111;
    opacity:50%;
`;
const Modal = styled.div`
    // z-index: 1;
    //z-index: 11;
    display: ${({show}) => (show ? "block" : "none")};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: ${({safty}) => (safty=="noSafty"? "16vh": "46vh")};
    width:57vw;
    background: #FFF;
    display:flex;
    border-radius: 10px;

    @media screen and (max-width: 850px){
        {
            // height: 50% !important;
            width: 100% !important;
        }
    } 
`

export const FeedModal = styled(Modal)`
    min-height:${({minheight}) => (minheight ? minheight  : "46vh")};    
    height: auto;
    width:${({width}) => (width ? width  : "57vw")};
    z-index: ${({zindex}) => (zindex ? zindex : "5")};
    
    @media screen and (max-width: 600px){
        {
            height: auto !important;
            width: ${({mblwidth}) => (mblwidth ? mblwidth  : "100%")} !important;            
        }
    } 
    @media screen and (min-width: 600px) and (max-width: 850px){
        {
            height: 80% !important;
            width: 100% !important;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: landscape){ }

    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: portrait){
        height: 80% !important;
        padding: 2em;
      }

    ${props => props.download && `
    @media screen and (max-width: 600px){
        {
            min-height: 100%;
            max-height: 115%;
            width: 100% !important;           
        }
    } 
    `}
    ${props => props.refer && `
        height: 16vh;
        @media screen and (max-width: 850px){
            {
                height: 15% !important;
                width: 95% !important;           
            }
        } 
        @media screen and (max-width: 600px){
                height: 25vh !important;
        }
    `}
`;

export const ShareCointainer = styled.div`
    display: flex;
    flex-flow: column;
    justify-content: center;
`

export const WelcomeCarouselModel = styled(Modal)`
    height: 65vh;
    width:34%;
    background: #F3F3F3;
    display:flex;
    flex-direction:row;
    z-index:13;
    @media screen and (max-resolution: 160dpi){
        {
            width: 35%;
            height:70vh !important;
        }
    }
    @media screen and (min-width: 1200px) and (max-width: 1400px){
        {
            width: 35%;
            height:82vh !important;
        }
    }
    @media screen and (min-width: 1400px) and (max-width: 1600px){
        {
            width: 35%;
            height:80vh !important;
        }
    }
    @media screen and (min-width: 1600px) and (max-width: 1600px){
        {
            width: 35%;
            height:65vh !important;
        }
    }
    @media screen and (max-width: 1366px)  {
        {
            width: 35%;
            height:78vh;
        }
    }
    
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            height: 70% !important;
            width:85% !important;
        }
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        & {
            height: 85% !important; 
            width: 52%;
        }
    }
    
    @media screen and (max-width: 740px){
        {
            height: 75%;
            width: 65% !important;
            z-index: 15;
        }
    } 
    @media screen  and (min-width: 390px)and (max-width: 620px){
        {
            height: 70vh !important;
            width: 90% !important;
        }
    }
    @media screen and (max-width: 390px){
        {   
           height: 85vh !important;
           width: 90% !important;
        }
    }    
`

export const ImgFeedModal = styled(Modal)`
    max-height: ${(props) => (props?.age ? "80%" : "100%")};
    // height: ${(props) => (props?.pdf ? "89%" : "71%")} !important;
    height: ${(props) => (props?.pdf ? "89%" : props?.isAnniversary?"80%":"70%")} !important;
    width: ${(props) => (props?.age ? "max-content" : props?.isAnniversary? "45vw" : "40vw")};
    justify-content: center;
    z-index:13;

    @media screen and (max-width: 750px){
        {
            max-height: 80% !important;
            height: ${(props) => (props?.pdf ? "75%" : props?.isAnniversary?"68%" :"max-content")} !important;
            min-height: 50% !important;
            width: ${(props) => (props?.pdf ? "77%" : props?.isAnniversary?"90%" : "90%")} !important;
        }
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) 
      and (orientation: portrait){
        width: ${(props) => (props?.pdf ? "77%" : "53%")} !important;
        height: ${(props) => (props?.pdf ? "75%" : props?.isAnniversary?"65%" :"50%")} !important;
        
      }
    @media screen and (max-width: 600px){
        {
            width: ${(props) => (props?.pdf ? "98%" : props?.isAnniversary?"90%" :"90%")} !important;
        }
    } 
    @media screen and (min-width: 1200px) and (max-width: 1400px){
        height: ${(props) => (props?.pdf ? "91.5%" : props?.isAnniversary?"90%": "75%")} !important;
    }
    @media screen and (min-width: 1600px) and (max-width: 1920px){
        height: ${(props) => (props?.pdf ? "83%" : props?.isAnniversary?"70%":"58%")} !important;
    }
`;

export const ChildImgModal = styled(Modal)`
    height: 80vh;
    width:40vw;
`;


export const ConnectFeedModalPopup = styled.div`
    z-index: 12;
    display: ${({show}) => (show ? "block" : "none")};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-height: 95%;
    width:40%;
    background: #FFFFFF;
    display:flex;
    border-radius: 10px;
    @media screen and (max-width: 850px){
    ${props => props.responsePopup && `
      height: 75%;
      width:70%
   `}
    }
    @media screen and (max-width: 520px){
        ${props => props.responsePopup && `
            width: 90%;
            height: 80%;
        `}
    }
`;

export const ConnectProgressModalPopup = styled.div`
    z-index: 12;
    display: ${({show}) => (show ? "block" : "none")};
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: auto;
    max-height: 98%;
    width:115vh;
    background: #FFFFFF;
    display:flex;
    border-radius: 10px;
    @media screen and (max-width: 1300px){
        height: auto;
        max-height: 98%;
    }
    @media screen and (max-width: 850px){
        width: 95%;
        height: 98%;
        padding: 2% 0 2% 0;
    }
`;

export const SRSFeedModal = styled(Modal)`
    height: auto;
    width:51vw;
    z-index:12;
    @media only screen and (max-width: 850px){
        height: auto !important;   
    }
`;

export const VideoFeedModal = styled(Modal)`
    min-height: 44vh;
    // height:max-content;
    height: ${({fullscreen}) => (fullscreen ? "100vh" : "80vh")};
    width: ${({fullscreen}) => (fullscreen ? "100vw" : "46vw")};
    // width:40vw;
    z-index:13;
    padding: ${({fullscreen}) => (fullscreen ? "0" : "0 0 1.2% 0")};
    transition: all 0.5s;   
    background-color: ${({fullscreen}) => (fullscreen ? "#000" : "#fff")};
    //overflow:hidden;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & {
            top:35%;
            width: 90vw !important;
        }
  }
  @media only screen and (max-width: 750px)  
    {
        & {
            padding: 4% 2%;
        }
  }
`;

export const ModalCloseButton = styled.button`{
    z-index: 10;
    position: absolute;
    width: 1.7vw;
    height: 5vh;
    right: 5px;
    top: 5px;
    background: ${props=>props.whiteIcon?`url(${closeIconWhite}) 0 0`:`url(${closeIconblack}) 0 0`};
    cursor: pointer;
    background-repeat: no-repeat;
    @media (min-width: 768px) and (max-width: 1023px){
        width: 21px;
        height: 21px;
        right: 0px;
        top: 15px;
    }
    @media screen and (max-width: 850px){
        width: 5vw;
    }
    ${props=>props.delete&&`
    @media screen and (max-width: 850px){
        right:0;
        width: 4vw;
    }
    @media screen and (max-width: 480px){
        right:10px;
        width: 5vw;
    }
    `}
}`;

export const ModalCloseButtonWhite = styled.button`{
    position: absolute;
    width: 1.7vw;
    height: 3vh;
    right: 12px;
    top: 12px;
    background: url(${closeIconWhite}) 0 0;
    background-repeat: no-repeat;
}`;
